document.addEventListener("DOMContentLoaded", function() {
    function calculateGelStrength() {
        let bloomStrength = parseFloat(document.getElementById("bloomStrength").value);
        let targetStrength = parseFloat(document.getElementById("targetStrength").value);
        let recipeAmount = parseFloat(document.getElementById("recipeAmount").value);
        let unit = document.getElementById("unit").value;
        
        if (isNaN(bloomStrength) || isNaN(targetStrength) || isNaN(recipeAmount) || bloomStrength <= 0 || targetStrength <= 0 || recipeAmount <= 0) {
            alert("Please enter valid positive numbers.");
            return;
        }
        
        let adjustedAmount = (bloomStrength / targetStrength) * recipeAmount;
        let resultText = `To achieve a target Bloom strength of ${targetStrength}, you need to use ${adjustedAmount.toFixed(2)} ${unit}.`;
        
        document.getElementById("result").innerHTML = `<h3>Adjusted Gelatin Amount:</h3><p>${resultText}</p>`;
    }
    
    document.getElementById("gel-strength-calculator").innerHTML = `
        <div style="padding: 20px; border: 1px solid #ddd; border-radius: 8px; max-width: 400px; margin: auto; background-color: #f9f9f9;">
            <h2 style="text-align: center;">Gel Strength & Bloom Calculator</h2>
            <label>Current Bloom Strength:</label>
            <input type="number" id="bloomStrength" style="width: 100%; padding: 5px; margin-bottom: 10px;" placeholder="Enter current bloom strength">
            
            <label>Target Bloom Strength:</label>
            <input type="number" id="targetStrength" style="width: 100%; padding: 5px; margin-bottom: 10px;" placeholder="Enter target bloom strength">
            
            <label>Recipe Amount:</label>
            <input type="number" id="recipeAmount" style="width: 100%; padding: 5px; margin-bottom: 10px;" placeholder="Enter recipe amount">
            
            <label>Unit:</label>
            <select id="unit" style="width: 100%; padding: 5px; margin-bottom: 10px;">
                <option value="grams">Grams</option>
                <option value="ounces">Ounces</option>
            </select>
            
            <button id="calculate-btn" style="width: 100%; padding: 10px; background: #FF7E00; color: white; border: none; border-radius: 5px; cursor: pointer;">
                Calculate
            </button>
            
            <div id="result" style="text-align: center; font-weight: bold; margin-top: 15px;"></div>
        </div>
    `;
    
    document.getElementById("calculate-btn").addEventListener("click", calculateGelStrength);
});
